import React, { Component } from "react"
import {
  VictoryChart,
  VictoryAxis,
  VictoryStack,
  VictoryTheme,
  VictoryBar,
  VictoryTooltip
} from "victory"

import Moment from "moment-timezone"
import "moment-duration-format"

const MAX_DATES_TO_DISPLAY = 40

class Chart extends Component {
  render() {
    const {
      validation_errors,
      weekly_work_time_duration,
      handleErrorClick
    } = this.props

    var daily_work_time = weekly_work_time_duration.asSeconds() / 5

    var data_work_time_correct = []
    var data_extra_time_correct = []
    var data_work_time_errors = []
    var data_over_limit = []
    var days = []
    var label_strings = []
    var day_counter = 1

    if (
      validation_errors &&
      validation_errors.days &&
      validation_errors.days.length > 0
    ) {
      validation_errors.days.forEach(function(day) {
        days.push(day_counter)
        label_strings.push(Moment(day.date).format("dd, DD.MM"))

        if (day.workTime / 3600 <= 10) {
          if (day.errors.length === 0) {
            if (day.workTime > daily_work_time) {
              data_work_time_correct.push({
                date: day_counter,
                work_time: daily_work_time / 3600,
                label: Moment.duration(day.workTime, "seconds").format(
                  "h[h ]m[m]"
                ),
                click_info: Moment(day.date).format("YYYY-MM-DD")
              })
              data_extra_time_correct.push({
                date: day_counter,
                work_time: (day.workTime - daily_work_time) / 3600,
                label: Moment.duration(day.workTime, "seconds").format(
                  "h[h ]m[m]"
                ),
                click_info: Moment(day.date).format("YYYY-MM-DD")
              })
            } else {
              data_work_time_correct.push({
                date: day_counter,
                work_time: day.workTime / 3600,
                label: Moment.duration(day.workTime, "seconds").format(
                  "h[h ]m[m]"
                ),
                click_info: Moment(day.date).format("YYYY-MM-DD")
              })
              data_extra_time_correct.push({
                date: day_counter,
                work_time: 0,
                label: Moment.duration(day.workTime, "seconds").format(
                  "h[h ]m[m]"
                ),
                click_info: Moment(day.date).format("YYYY-MM-DD")
              })
            }

            data_work_time_errors.push({
              date: day_counter,
              work_time: 0,
              label: Moment.duration(day.workTime, "seconds").format(
                "h[h ]m[m]"
              ),
              click_info: Moment(day.date).format("YYYY-MM-DD")
            })
          } else {
            data_work_time_correct.push({
              date: day_counter,
              work_time: 0,
              label: Moment.duration(day.workTime, "seconds").format(
                "h[h ]m[m]"
              ),
              click_info: Moment(day.date).format("YYYY-MM-DD")
            })
            data_extra_time_correct.push({
              date: day_counter,
              work_time: 0,
              label: Moment.duration(day.workTime, "seconds").format(
                "h[h ]m[m]"
              ),
              click_info: Moment(day.date).format("YYYY-MM-DD")
            })
            data_work_time_errors.push({
              date: day_counter,
              work_time: day.workTime / 3600,
              label: Moment.duration(day.workTime, "seconds").format(
                "h[h ]m[m]"
              ),
              click_info: Moment(day.date).format("YYYY-MM-DD")
            })
          }

          data_over_limit.push({
            date: day_counter,
            work_time: 0,
            label: Moment.duration(day.workTime, "seconds").format("h[h ]m[m]"),
            click_info: Moment(day.date).format("YYYY-MM-DD")
          })
        } else {
          data_work_time_correct.push({
            date: day_counter,
            work_time: 0,
            label: Moment.duration(day.workTime, "seconds").format("h[h ]m[m]"),
            click_info: Moment(day.date).format("YYYY-MM-DD")
          })
          data_extra_time_correct.push({
            date: day_counter,
            work_time: 0,
            label: Moment.duration(day.workTime, "seconds").format("h[h ]m[m]"),
            click_info: Moment(day.date).format("YYYY-MM-DD")
          })
          data_work_time_errors.push({
            date: day_counter,
            work_time: 10,
            label: Moment.duration(day.workTime, "seconds").format("h[h ]m[m]"),
            click_info: Moment(day.date).format("YYYY-MM-DD")
          })
          data_over_limit.push({
            date: day_counter,
            work_time: day.workTime / 3600 - 10,
            label: Moment.duration(day.workTime, "seconds").format("h[h ]m[m]"),
            click_info: Moment(day.date).format("YYYY-MM-DD")
          })
        }

        day_counter++
      })

      return (
        <div style={{ width: "100%" }}>
          <VictoryChart
            domainPadding={40}
            theme={VictoryTheme.material}
            preserveAspectRatio="none"
            width={700}
            height={250}
          >
            <VictoryAxis
              tickValues={days}
              tickFormat={label_strings}
              style={
                days.length <= MAX_DATES_TO_DISPLAY
                  ? {
                      tickLabels: {
                        fontSize: "10px",
                        angle: -90,
                        padding: 20
                      }
                    }
                  : { tickLabels: { fontSize: "0px" } }
              }
            />
            <VictoryAxis
              dependentAxis
              tickFormat={x => `${x}h`}
              style={{ tickLabels: { fontSize: "12px" } }}
            />
            <VictoryStack colorScale={["#1bbbe9", "#0096c0", "orange", "red"]}>
              <VictoryBar
                labelComponent={
                  <VictoryTooltip
                    cornerRadius={0}
                    pointerLength={0}
                    flyoutStyle={{
                      stroke: "#1bbbe9"
                    }}
                  />
                }
                data={data_work_time_correct}
                x="date"
                y="work_time"
                label="label"
              />

              <VictoryBar
                labelComponent={
                  <VictoryTooltip
                    cornerRadius={0}
                    pointerLength={0}
                    flyoutStyle={{
                      stroke: "#0096c0"
                    }}
                  />
                }
                data={data_extra_time_correct}
                x="date"
                y="work_time"
                label="label"
              />

              <VictoryBar
                labelComponent={
                  <VictoryTooltip
                    cornerRadius={0}
                    pointerLength={0}
                    flyoutStyle={{
                      stroke: "orange"
                    }}
                  />
                }
                data={data_work_time_errors}
                x="date"
                y="work_time"
                label="label"
                events={[
                  {
                    target: "data",
                    eventHandlers: {
                      onClick: (evt, clickedProps) => {
                        handleErrorClick(
                          clickedProps.data[clickedProps.index].click_info,
                          true
                        )
                      }
                    }
                  }
                ]}
              />
              <VictoryBar
                labelComponent={
                  <VictoryTooltip
                    cornerRadius={0}
                    pointerLength={0}
                    flyoutStyle={{
                      stroke: "red"
                    }}
                  />
                }
                data={data_over_limit}
                x="date"
                y="work_time"
                label="label"
                events={[
                  {
                    target: "data",
                    eventHandlers: {
                      onClick: (evt, clickedProps) => {
                        handleErrorClick(
                          clickedProps.data[clickedProps.index].click_info,
                          true
                        )
                      }
                    }
                  }
                ]}
              />
            </VictoryStack>
          </VictoryChart>
        </div>
      )
    } else {
      return null
    }
  }
}

export default Chart



// WEBPACK FOOTER //
// ./src/components/Chart.jsx